import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetChatNPSRating($id: ID!) {
    chat(id: $id) {
      id
      npsRating
    }
  }
`);
